export const PLANS = {
  free: {
    id: "free",
    name: "Free",
    fullName: "Scout Free",
    price: 0,
    earlyPrice: 0,
    agentMinutes: 60,
    maxConcurrentJams: 1,
    maxCustomSubdomains: 0,
    features: ["60 monthly agent minutes", "Run up to 1 concurrent jam"],
  },
  lite: {
    id: "lite",
    name: "Lite",
    fullName: "Scout Lite",
    price: 39,
    earlyPrice: 19,
    agentMinutes: 360,
    maxConcurrentJams: 2,
    maxCustomSubdomains: 5,
    features: [
      "6 monthly agent hours",
      "Run up to 2 concurrent jams",
      "Up to 5 custom subdomains",
      "Priority access during peak load",
      "Dedicated Discord support",
    ],
  },
  pro: {
    id: "pro",
    name: "Pro",
    fullName: "Scout Pro",
    price: 199,
    earlyPrice: 99,
    agentMinutes: 1800,
    maxConcurrentJams: 5,
    maxCustomSubdomains: 10,
    features: [
      "30 monthly agent hours",
      "Run up to 5 concurrent jams",
      "Up to 10 custom subdomains",
      "Priority access during peak load",
      "Dedicated Discord support",
      "Early access to instance customization, custom instructions, and other beta features",
    ],
  },
};

export const EXTRA_HOURS = {
  30: {
    price: 199,
    extraMinutes: 1800,
  },
};
